export default {
    'markerUrlIconBlack': 'images/markers/marker_notary_black.png',
    'markerUrlIconWhite': 'images/markers/marker_notary_white.png',
    'markerUrlIconDefault': 'images/markers/marker.png'
}



// WEBPACK FOOTER //
// ./resources/assets/js/factories/googlemaps/googleMapsMarkers.js